import { create } from "zustand";
import { STORAGE_KEYS } from "../constants/storage";

const STORAGE_KEY = STORAGE_KEYS.theme;

function getInitialDark(): boolean {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === "dark") return true;
  if (stored === "light") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

function applyDark(isDark: boolean) {
  if (isDark) {
    document.documentElement.classList.add("dark");
  } else {
    document.documentElement.classList.remove("dark");
  }
}

interface DarkModeState {
  isDark: boolean;
  toggle: () => void;
}

export const useDarkModeStore = create<DarkModeState>((set) => {
  const initial = getInitialDark();
  applyDark(initial);

  return {
    isDark: initial,
    toggle: () =>
      set((state) => {
        const next = !state.isDark;
        localStorage.setItem(STORAGE_KEY, next ? "dark" : "light");
        applyDark(next);
        return { isDark: next };
      }),
  };
});
